import { Link } from 'react-router-dom';

export const NavigationItem = ({ item, mobile = false, onClick }) => {
    const Icon = item.icon;
    return (
        <Link
            to={item.href}
            onClick={onClick}
            className={`${item.current
                ? 'bg-blue-50 dark:bg-gray-900 text-blue-700 dark:text-white'
                : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                } ${mobile ? 'flex' : 'group flex'
                } items-center px-2 py-2 text-sm font-medium rounded-md`}
        >
            <Icon className="mr-3 h-5 w-5" />
            {item.name}
        </Link>
    );
};